import type { TaskLogEntry } from '../../api/hooks/useTaskLog';
import './TaskTimeline.css';

function formatTime(ts: number): string {
  if (!ts) return '—';
  return new Date(ts).toLocaleTimeString();
}

export function TaskTimeline({ entries }: { entries: TaskLogEntry[] }) {
  if (entries.length === 0) {
    return <p className="nx-task-timeline__empty">No log entries yet.</p>;
  }
  const sorted = [...entries].sort((a, b) => a.ts - b.ts);
  return (
    <ol className="nx-task-timeline" aria-label="Task event timeline">
      {sorted.map((e, i) => (
        <li
          key={`${e.ts}-${e.event}-${i}`}
          className={`nx-task-timeline__entry nx-task-timeline__entry--${e.level ?? 'info'}`}
        >
          <span className="nx-task-timeline__dot" aria-hidden="true" />
          <div className="nx-task-timeline__body">
            <div className="nx-task-timeline__head">
              <strong>{e.event}</strong>
              <time>{formatTime(e.ts)}</time>
            </div>
            {e.detail && <div className="nx-task-timeline__detail">{e.detail}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}